module.exports = __webpack_public_path__ + "static/media/sao-tome-and-principe.232b0c8a.png";